// extracted by mini-css-extract-plugin
export default {"errorIcon":"CheckboxCell_errorIcon__pDes9","successIcon":"CheckboxCell_successIcon__Xz8Y3"};